/**
 * 发行SDK版本
 */
export const SDK_VERSION = '2.15.0'
